import { invokeCheckout } from "@/lib/checkoutRouter";
import { trackBeginCheckout } from "@/lib/analytics";
import { supabase } from "@/integrations/supabase/client";


/**
 * Arranca el checkout del Club Pro (69 €/mes).
 *
 * Sin sesión guardamos la intención de compra y devolvemos "needs-auth" para
 * que la pantalla abra el registro; tras registrarse el checkout se reanuda.
 */
export async function startProCheckout(opts: {
  isAuthenticated: boolean;
  lang: "es" | "en";
}): Promise<"needs-auth" | "opened" | "blocked" | "error"> {
  if (!opts.isAuthenticated) {
    try {
      localStorage.setItem(
        "pending_checkout",
        JSON.stringify({
          product_type: "pro",
          product_key: "pro",
          billing_interval: "month",
          is_paid_intent: true,
        }),
      );
    } catch {
      /* almacenamiento no disponible */
    }
    return "needs-auth";
  }

  // El recuadro Lite/Club Pro solo se muestra a usuarios ya registrados y
  // aceptados, así que su CTA abre siempre el pago aunque la Beta Privada siga
  // activa para el resto de flujos.


  const { data, error } = await invokeCheckout( {
    body: { product_type: "pro", product_key: "pro", billing_interval: "month" },
  });
  if (error || !data?.url) return "error";
  trackBeginCheckout({ source: "club_pro", productType: "pro", productKey: "pro", interval: "month", valueCents: 9900 });
  window.open(data.url, "_blank");
  return "opened";
}
